import './listMusicById.scss';
import { GlobalOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import {
  playlistByIdBeezer,
  selectPlaylist
} from '@/features/playlist/playlistSlice';
import { useEffect, useRef } from 'react';
import { Spinner } from '@/components/atoms/Spinner';
import { TrackItem } from '@/components/molecules/TrackItem';
import { IPropsListId } from '@/interface';
import { HeaderPlaylist } from '@/components/atoms/HeaderPlaylist';
import { ValidateIcon } from '@/components/molecules/ValidateIcon';
import { useParams } from 'react-router-dom';
import { ShareTrack } from '@/components/atoms/ShareTrack';
import { testWebShare } from '@/utils/webShare';

export const ListMusicById = ({ isGuest }: IPropsListId) => {
  const {
    status,
    playlistsId: { tracks, name, description, followers, images, owner }
  } = useAppSelector(selectPlaylist);

  const navigation = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const params = useParams();

  useEffect(() => {
    if (!params.id) return;
    if (isGuest) {
      dispatch(playlistByIdBeezer(params.id));
    }
  }, [dispatch, isGuest, params.id]);
  return (
    <>
      {status.playlistIdState === 'loading' ? (
        <Spinner />
      ) : (
        <aside className='o-listId' ref={navigation}>
          <span className='o-listId__share'>
            <ShareTrack
              onTouchStart={() =>
                testWebShare({
                  text: name + ' ' + window.location.href,
                  files: [images && images[0].url]
                })
              }
            />
          </span>
          <HeaderPlaylist
            image={images && images[0].url}
            name={name}
            navigation={navigation}
            title={name}
          />
          <section className='o-listId__info'>
            <h2 className='o-listId__title'>{name}</h2>
            <p className='o-listId__description'>{description}</p>
            <div className='o-listId__actions'>
              <ValidateIcon isGuest={isGuest} />
              <span className='o-listId__actions-owner'>
                {owner?.display_name}
              </span>
            </div>

            <div className='o-listId__actions'>
              <GlobalOutlined />{' '}
              <span className='o-listId__actions-followers'>
                {followers?.total}
                {'followers'}
              </span>
            </div>
          </section>
          <section className='o-listId__tracks'>
            <TrackItem tracks={tracks} isGuest={isGuest} />
          </section>
        </aside>
      )}
    </>
  );
};
